var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 137,
    viewBox: "0 0 135 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M67.404 136.063C104.609 136.083 134.779 105.616 134.81 68.062C134.778 30.452 104.608 -0.0139952 67.404 4.82312e-06C30.19 -0.0139952 0.025 30.452 0 68.062C0.025 105.616 30.19 136.083 67.404 136.063ZM67.404 15.674C96.035 15.674 119.243 39.117 119.21 68.066C119.241 96.954 96.035 120.398 67.404 120.386C38.765 120.399 15.555 96.95 15.522 68.062C15.555 39.118 38.765 15.674 67.404 15.674Z",
    fill: "#007A33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2571 96.4201C77.5991 96.4201 77.0591 95.6491 77.0591 94.7011V54.4741H51.9331V59.6381H56.4801C57.1391 59.6381 57.6681 60.1771 57.6681 60.8371V95.2241C57.6681 95.8831 57.1331 96.4221 56.4801 96.4221H51.9331V101.758H83.1571V96.4221L78.2571 96.4201Z",
    fill: "#007A33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3671 29.436C73.3151 29.436 78.1451 34.261 78.1451 40.215C78.1451 46.169 73.3151 50.995 67.3671 50.995C61.4081 50.995 56.5811 46.169 56.5811 40.215C56.5811 34.261 61.4071 29.436 67.3671 29.436Z",
    fill: "#007A33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.749a3aab4545b9b6a88dfa482116e7c1.svg";
export { ForwardRef as ReactComponent };